/* 网上报修API */

import { GET, POST, download, uploading, POSTFormData, EXPORT, DELETE, PUT } from '@/request/http'
// 维修事项

// 新增
export const repairItemSave = p => POST('/repair/item/save', p, 5)
// 编辑
export const repairItemUpdate = p => POST('/repair/item/update', p, 5)
// 删除
export const repairItemremove = p => POST('/repair/item/remove', p, 5)
// 列表
export const repairItemList = p => POST('/repair/item/list', p, 5)
// 分页
export const repairItemPage = p => POST('/repair/item/page', p, 5)
// 根据id查询
export const repairItemById = p => POST('/repair/item/get', p, 5)

// 事项分组
// 新增
export const repairItemClasifySave = p => POST('/repair/itemclassify/save', p, 5)
// 编辑
export const repairItemClasifyUpdate = p => POST('/repair/itemclassify/update', p, 5)
// 删除
export const repairItemClasifyremove = p => POST('/repair/itemclassify/remove', p, 5)
// 列表
export const repairItemClasifyList = p => POST('/repair/itemclassify/list', p, 5)
// 根据id查询
export const repairItemClasifyById = p => POST('/repair/itemclassify/get', p, 5)

// 维修人员管理
// 新增
export const repairerSave = p => POST('/repair/repairer/save', p, 5)
// 删除
export const repairerRemove = p => POST('/repair/repairer/remove', p, 5)
// 查询list
export const repairerList = p => GET('/repair/repairer/list', p, 5)
// 派工人管理
// 新增
export const repairOrderSave = p => POST('/repair/assigner/save', p, 5)
// 删除
export const repairOrderRemove = p => POST('/repair/assigner/remove', p, 5)
// 查询list
export const repairOrderList = p => POST('/repair/assigner/page', p, 5)
// 订单

// 查询待完工
export const getWaitfinishPage = p => POST('/repair/order/waitfinish/page', p, 5)
// 查询我的订单列表
export const repairGetOrerByCurrentuser = p => POST('/repair/order/page/bycurrentuser', p, 5)
// 派工
export const repairAssign = p => POST('/repair/order/assign', p, 5)
// 挂起
export const repairHangUp = p => POST('/repair/order/hangup', p, 5)
// 完成
export const repairFinish = p => POST('/repair/order/finish', p, 5)
// 退回
export const repairRevocation = p => POST('/repair/order/revocation', p, 5)

// 查询待派工
export const getRepairWaitAssign = p => POST('/repair/order/waitassign/page', p, 5)
// 所有订单
export const getRepairOrderPage = p => POST('/repair/order/page', p, 5)
// 查询评价
export const getEvaluatePage = p => POST('/repair/evaluate/page', p, 5)

//班次管理
//新增班次
export const addWorkClasses = p => POST('/repair/work-shifts', p, 5)
//删除班次
export const deleteWorkClasses = p => DELETE('/repair/work-shifts/{id}', p, 5)
//查询所有班次
export const getAllWorkClasses = p => GET('/repair/work-shifts/{current}/{size}', p, 5)
//更新班次
export const editWorkClasses = p => PUT('/repair/work-shifts/{id}', p, 5)

//获取部门信息
export const getDepartmentsList = p => GET('/basic/departments', p, 5)
//查询全部部门
export const getRepairDepList = p => GET('/basic/departments/allcurrent', p, 5)

//部门权限管理
//维修部门权限新增
export const addRepairDepJurisdiction = p => POST('/repair/dept-repair-scopes', p, 5)
//根据维修范围id获取具体事项和地点
export const getRepairThingAndLocationByScopeId = p => GET('/repair/dept-repair-scopes/{scopeId}/items-locations', p, 5)
//维修部门权限编辑
// export const editRepairDepJurisdiction = p => PUT('/repair/dept-repair-scopes/{id}/basic-info', p, 5)
//编辑部门权限
//更新基础信息(范围名称)
export const editRepairDepJurisdictionScopeName = p => PUT('/repair/dept-repair-scopes/{id}/basic-info', p, 5)
//更新维修事项
export const editRepairDepJurisdictionThing = p => PUT('/repair/dept-repair-scopes/{id}/items', p, 5)
//更新维修范围
export const editRepairDepJurisdictionLocations = p => PUT('/repair/dept-repair-scopes/{id}/locations', p, 5)
//维修部门权限删除
export const removeRepairDepJurisdiction = p => DELETE('/repair/dept-repair-scopes/{id}', p, 5)
//获取当前用户下所有部门的维修范围
export const getRepairDepJurisdictionAll = p => GET('/repair/dept-repair-scopes/{deptId}', p, 5)
//根据id查询楼宇信息
export const getRepaitScopesList = p => POST('/repair/dept-repait-scopes', p, 5)
//获取当前部门所有事项和地点
export const getAtPresentDepScopeList = p => GET('/repair/dept-repait-all', p, 5)
//(对象)根据部门id获取当前部门所有的维修范围及事项和地点
export const getAtPresentDepAllScopeListByDepId = p => GET('/repair/dept-repair-scopes/{deptId}/object', p, 5)

//维修工权限管理
//维修工权限新增
export const addRepairWorkerJurisdiction = p => POST('/repair/repairer/scope', p, 5)
//维修工权限编辑(范围名称)
export const editRepairWorkerScopeName = p => PUT('/repair/repairer/basicinformation/{id}', p, 5)
//维修工权限编辑(维修工)
export const editRepairWorkerList = p => PUT('/repair/repairer/{id}', p, 5)
//维修工权限编辑(工作日期)
export const editRepairWorkerWorkDate = p => PUT('/repair/repairer/datetime/{id}', p, 5)
//维修工权限编辑(工作班次)
export const editRepairWorkerWorkClasses = p => PUT('/repair/repairer/workshift/{id}', p, 5)
//维修工权限编辑(维修事项)
export const editRepairWorkerThing = p => PUT('/repair/repairer/items/{id}', p, 5)
//维修工权限编辑(维修位置)
export const editRepairWorkerLocation = p => PUT('/repair/repairer/locations/{id}', p, 5)
//维修工权限删除
export const removeRepairWorkerJurisdiction = p => DELETE('/repair/repairer/scope/{id}', p, 5)
//获取当前部门所有维修工的维修范围
export const getAtPresentDepAllWorkerScopeList = p => GET('/repair/repairer/all/{size}/{current}', p, 5)
//根据部门id获取部门下维修工维详情列表
export const getAllWorkerRepairScopeByDepId = p => GET('/repair/repairer/get-dept-repairers/{dept}', p, 5)
//根据部门id查询当前部门的人员列表
export const getAllWorkerListByDepId = p => GET('/repair/repairer/get-repairers/{deptId}', p, 5)
//根据所选id获取要编辑的数据
export const getEditRepairScopeById = p => GET('/repair/repairer/{id}', p, 5)
//获取当前用户所在部门信息
export const getAtPresentUserDepInfo = p => GET('/basic/departments/getcurrentinfo', p, 5)

// 根据楼宇id获取维修事项
export const getRepairThingByBuildId = p => GET('/repair/items/{building}', p, 5)
// 提交维修
export const repairOrderSubmit = p => POSTFormData('/repair/order/submit', p, 5)

//统计分析
//维修工维修情况统计
export const getRepairWorkerRepairInfoList = p => GET('/repair/statistics/repairerrepair/get', p, 5)
//各维修事项维修情况统计
export const getRepairThingRepairInfoList = p => GET('/repair/statistics/itemrepair/get', p, 5)
//各楼宇事项维修情况统计
export const getRepairLocationRepairInfoList = p => GET('/repair/statistics/buildingrepair/get', p, 5)
//各部门维修情况统计
export const getRepairDepRepairInfoList = p => GET('/repair/statistics/deptrepair/get', p, 5)
//各日期事项维修情况统计
export const getRepairDateRepairInfoList = p => GET('/repair/statistics/daterepair/get', p, 5)
//维修状态统计
export const getRepairStatistics = p => GET('/repair/statistics', p, 5)

// 设置
//查询当前用户是否开启接单功能状态
export const getRepairConfig = p => GET('/repair/config/status', p, 5)
//开启关闭接单功能
export const updateRepairTakeOrderConfig = p => PUT('/repair/config/orders', p, 5)
//开启关闭提醒派工员短信功能
export const updateRepairSMSConfig = p => PUT('/repair/config/sms', p, 5)

//接单
export const repairGetOrder = p => PUT('/repair/order/{orderNo}/orders', p, 5)
//导出
export const exportRepairExcel = p => EXPORT('/repair/order/export', p, 5)

//更新报修功能
export const updateRepairFunctionType = p => PUT('/repair/config/open-close-user-config', p, 5)
//根据订单号查询订单详情
export const getRepairOrderDetailByOrderNo = p => GET('/repair/order/{orderNo}/details', p, 5)
//编辑订单
export const editRepairOrderDetail = p => PUT('/repair/order/update', p, 5)

/**
 *  大屏统计
 */
//学校不同状态维修量统计
export const getRepairNumberByStatus = p => GET('/repair/statistics/repair-number/{campusId}', p, 5)
//校区所有楼宇维修量
export const getRepairNumberByBuilding = p => GET('/repair/statistics/repair-building-number/{campusId}', p, 5)
//报修时间分布
export const getRepairNumberByTime = p => GET('/repair/statistics/repair-time/{campusId}', p, 5)
//报修事项统计
export const getRepairItemStatistics = p => GET('/repair/statistics/repair-item-number/{campusId}', p, 5)
//楼宇维修量及维修用时
export const getRepairNumberAndTimeByBuilding = p => GET('/repair/statistics/repair-building-number-time/{campusId}', p, 5)
//楼宇维修完成情况
export const getRepairCompletionByBuilding = p => GET('/repair/statistics/repair-building-complete-number/{campusId}', p, 5)



// WEBPACK FOOTER //
// ./src/api/modules/repair.js